import {combine} from 'effector';
import {createGate} from 'effector-react';

import {blockNkEmployee, fetchAppealThemes, fetchNkEmployees, unblockNkEmployee} from 'api';
import {rootDomain} from 'core/rootDomain';
import {AppealTheme, NkEmployee} from 'types';

const domain = rootDomain.createDomain('personnelNkDomain');

export const Gate = createGate('PersonnelNkGate');
export const fetchEmployeesFx = domain.createEffect({
    name: 'fetchPersonnelNkEmployeesFx',
    handler: fetchNkEmployees,
});
export const fetchThemesFx = domain.createEffect({
    name: 'fetchPersonnelNkThemesFx',
    handler: fetchAppealThemes,
});
export const blockEmployeeFx = domain.createEffect({
    name: 'blockPersonnelNkEmployeeFx',
    handler: blockNkEmployee,
});
export const unblockEmployeeFx = domain.createEffect({
    name: 'unblockPersonnelNkEmployeeFx',
    handler: unblockNkEmployee,
});

export const employees$ = domain.createStore<NkEmployee[]>([]);
export const themes$ = domain.createStore<AppealTheme[]>([]);

export const personnelNkState$ = combine({
    employees: employees$,
    themes: themes$,
    isLoading: combine(
        fetchEmployeesFx.pending,
        fetchThemesFx.pending,
        (employeesPending, themesPending) => employeesPending || themesPending,
    ),
});
